
  import { Component, Vue } from 'vue-property-decorator';
  import axios from 'axios';
  import { i18n } from '@/localizer';
  import settings from '../config';

  @Component({
    data() {
      return {
        FB: undefined,
      };
    },
    created() {
      const asyncLoadFb = (d: any, s: any, id: any) => {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        const js = d.createElement(s);
        js.id = id;
        js.src = `//connect.facebook.net/${i18n.locale}/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
      };

      asyncLoadFb(document, 'script', 'facebook-jssdk');
    },
    mounted() {
      const appId = settings.VUE_APP_APP_ID;
      const version = settings.VUE_APP_API_VERSION;
      const vm = this as FacebookLogin;

      if (this.$store.state.fbInitialized === false) {
        (window as any).fbAsyncInit = () => {
          FB.init({
            appId,
            cookie: true,
            xfbml: true,
            version,
          });

          FB.Event.subscribe('auth.statusChange', vm.statusChangeCallback);

          FB.getLoginStatus(() => {
            this.$store.commit('fbInitialized', true);
          });

        };
      }
    },
  })
  export default class FacebookLogin extends Vue {
    public scope = 'pages_manage_metadata, email, public_profile, business_management, ' + settings.VUE_APP_EXTRA_PERMISSIONS;
    public translationSection = settings.VUE_APP_TRANSLATION_SECTION;
    public loadingLogin = false;
    private errors: any[] = [];

    private getProfile() {
      const vm = this as FacebookLogin;
      FB.api('/me?fields=name,id,email,picture', (response: any) => {
        this.$store.commit('profile', response);
      });
    }

    private statusChangeCallback(response: IFacebookUserAuthenticate) {
      this.loadingLogin = true;

      if (response.status === 'connected' && response.authResponse) {
        axios.post((settings.VUE_APP_API_ADDRESS || settings.VUE_APP_BASE_URL) + 'activation/ExtendToken',
        {
          token: response.authResponse.accessToken,
          appId: settings.VUE_APP_APP_ID,
        })
        .then((resp) => {
          this.$store.commit('login', {status: true, accessToken: resp.data.access_token});
          this.getPages(this.$store.state.userAccessToken);
          this.getProfile();
        })
        .catch((e) => {
          this.errors.push('Extending user token failed');
        })
        .finally(() => {
          this.loadingLogin = false;
        });
      } else {
        this.$store.commit('login', {status: false, accessToken: ''});
        this.$store.commit('profile', {});
        this.loadingLogin = false;
      }
    }

    private getPages(userToken: string) {
      const graphBase = `https://graph.facebook.com/${settings.VUE_APP_API_VERSION}`;
      axios.get(graphBase + `/me/accounts?access_token=${userToken}&limit=1000`)
      .then((response) => {
        this.$store.commit('pages', response.data.data);
      })
      .catch((e) => {
        this.errors.push(e);
      });
    }
  }
